import {playSoundEffect} from "./sounds.js"

$(document).ready(function() {
    const $dropdownMenus = $('.main-menu, #matches, #main-menu-buttons');
    const $html = $('html');

    // Show/hide dropdown menu upon clicking on dropdown button
    $dropdownMenus.on('click', '.button-dropdown', function () {
        if ($(this).hasClass('disabled')) {
            notie.alert({type: 4, text: 'You cannot edit this Match/Segment.'});
            return false;
        }
        playSoundEffect('success');
        let t = $(this).children(".dropdown-menu").is(":hidden");
        $(".button-dropdown .dropdown-menu").hide();
        $(".button-dropdown").removeClass("selected");
        if (t) {
            $(this).children(".dropdown-menu").toggle().parents(".button-dropdown").addClass("selected")
        }
    });

    // Hide dropdown menu when clicking anywhere else
    $html.on("click", function (t) {
        let n = $(t.target);
        const $dropdownMenu = $(".button-dropdown .dropdown-menu");
        if (n.closest('.button-dropdown').length <= 0 && $dropdownMenu.is(":visible")) {
            $dropdownMenu.hide();
            $(".button-dropdown").removeClass("selected");
        }
    });

    // Hide dropdown menu upon clicking its item. Keep dropdown button selected.
    $dropdownMenus.on('click', '.dropdown-menu li', function (e) {
        e.preventDefault();
        e.stopPropagation();
        playSoundEffect('success');

        // Show error if disabled, don't select
        if ($(this).hasClass('disabled')) {
            let errorText = $(this).data('tipText');
            notie.alert({
                type: 3, text: errorText,
                stay: true
            });
            return false;
        }

        // Select this item, hide dropdown
        $('.dropdown-menu').children().removeClass('selected');
        $(this).addClass('selected');
        $(this).parent().hide();
        $(this).closest('.button-dropdown').siblings().removeClass('selected');

        // Hide event effects
        $('.event-prestige-effects-container').hide();
        $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');
    });

    // Show help text
    $(document).on({
        mouseenter: function () {
            let title = $(this).attr('title');
            if (title) {
                $(this).data('tipText', title).removeAttr('title');
                $('<p class="tooltip"></p>').text(title).appendTo('body').fadeIn('fast');
            }
        },
        mouseleave: function () {
            $(this).attr('title', $(this).data('tipText'));
            $('.tooltip').remove();
            // Remove help text for multi match check box upon checking it
            if ($(this).attr('id') === 'multi-match-button' && $(this).find('.fa').hasClass('fa-check-circle-o')) {
                $(this).removeClass('help-text').attr('title', '');
            }
        },
        mousedown: function () {
            $('.tooltip').remove();
        },
        mousemove: function (e) {
            let mouseX = e.pageX + 20; //Get X coordinates
            let mouseY = e.pageY + 10; //Get Y coordinates
            $('.tooltip').css({top: mouseY, left: mouseX});
        },
        touchstart: function (e) {
            $('.tooltip').remove();
            let title = $(this).attr('title');
            if (title) {
                $('<p class="tooltip"></p>').text(title).appendTo('body').fadeIn('fast');
                let xPos = e.originalEvent.touches[0].pageX + 40; //Get X coordinates
                let yPos = e.originalEvent.touches[0].pageY - 30; //Get Y coordinates
                $('.tooltip').css({top: yPos, left: xPos});
            }
        },
        touchend: function () {
            $(this).attr('title', $(this).data('tipText'));
            $('.tooltip').remove();
        },
    }, ".help-text");
});